import { render } from "./WebsiteList.vue?vue&type=template&id=415e32e0&ts=true"
import script from "./WebsiteList.vue?vue&type=script&lang=ts"
export * from "./WebsiteList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__